import TestOrdersPage from './TestOrdersPage';

export default TestOrdersPage;
